export default [
    {path: 'add'},      
    {path: 'edit/:item_id'} ,     
    {path: 'save_as/:item_id'} ,
    {path: 'report/:item_id'} ,
    {path: 'details/:item_id'} ,
]